import React, { Component, useContext } from 'react';
import { Route } from 'react-router';
import { withRouter } from 'react-router-dom';
import { authService } from './services/auth.service';
import { createBrowserHistory } from 'history';
import MsalProviderClient from './components/MsalProviderClient';
import { AuthProvider } from './contexts/AuthContext';

import { AppContext } from './AppContext';
import ImpersonateUser from './components/ImpersonateUser';
import UnauthorizedAccess from './components/UnauthorizedAccess';
import UserManagement from './pages/UserManagement';
import CarreraEvaluacion from './pages/CarreraEvaluacion';

import { AuthLayoutWrapper } from './components/AuthLayoutWrapper';
import { Home } from './components/Home';
import { MisParalelos } from './components/MisParalelos';
import UnidadEvaluacion from './components/UnidadEvaluacion';
import AdmisionesEvaluacion from './components/AdmisionesEvaluacion';
import { ProgramaEvaluacion } from './components/ProgramaEvaluacion';
import UnidadParalelos from './components/UnidadParalelos';
import { Materias } from './components/Materias';
import { ParalelosMateria } from './components/ParalelosMateria';
import { Profesores } from './components/Profesores';
import { ParalelosProfesor } from './components/ParalelosProfesor';
import { Paralelo } from './components/Paralelo';
import { Practica } from './components/Practica';
import { Comentarios } from './components/Comentarios';
import ComentariosPractica from './components/ComentariosPractica';
import ReportesConsolidados from './components/ReportesConsolidados';
import ReportesTecnologias from './components/ReportesTecnologias';

import { GraficoParaleloArea } from './components/GraficoParaleloArea';

import './assets/css/main.css';
import { Switch } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { jwtDecode } from 'jwt-decode';

const history = createBrowserHistory();
const cookies = new Cookies();

const BASEURL = process.env.REACT_APP_BASE_URL;

class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);

        this.state = {
            currentUser: null
        };
    }

    componentDidCatch(error, errorInfo) {
        console.log("error = " + error + " errorInfo = " + errorInfo);
    }

    componentDidMount() {
        this.subscription = authService.currentUser.subscribe(currentUser => {
            if (currentUser) {
                this.setState({ currentUser: currentUser });
            }
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    startImpersonation = (impersonationToken) => {
        const decodedToken = jwtDecode(impersonationToken);
        cookies.set('impersonateToken', impersonationToken, {
            path: '/'
        });
        authService.validateToken(impersonationToken, decodedToken, true);
    };

    revertToOriginalUser = () => {
        const originalToken = cookies.get('authToken');
        const decodedToken = jwtDecode(originalToken);
        cookies.remove('impersonateToken', { path: '/' });
        authService.validateToken(originalToken, decodedToken);
        this.props.history.push('/');
    };

    render() {
        const { currentUser } = this.state;

        return (
            <MsalProviderClient>
                <AuthProvider>
                    <AppContext.Provider value={{ ...this.state, startImpersonation: this.startImpersonation, revertToOriginalUser: this.revertToOriginalUser }}>
                        <Switch>
                            <Route path='/grafico-area/:anio/:termino/:codigo/:paralelo/:identificacion/:area' component={GraficoParaleloArea} />
                            <AuthLayoutWrapper currentUser={currentUser}>
                                <Route exact path='/' component={Home} />
                                <Route path="/unauthorized" component={UnauthorizedAccess} />
                                <Route path='/usuarios' component={UserManagement} />
                                <Route path='/impersonate' component={ImpersonateUser} />

                                <Route path='/materias/:page?/:size?/:search1?/:search2?' component={Materias} />
                                <Route path='/profesores/:page?/:size?/:search1?/:search2?' component={Profesores} />

                                <Route path='/carrera-evaluacion/:carrera?/:anio?/:termino?/:page?/:size?' component={CarreraEvaluacion} />

                                <Route path='/mis-paralelos/:page?/:size?' component={MisParalelos} />
                                <Route path='/unidad-evaluacion/:unidad?/:anio?/:termino?/:page?/:size?' component={UnidadEvaluacion} />
                                <Route path='/admisiones-evaluacion/:anio?/:termino?/:page?/:size?' component={AdmisionesEvaluacion} />
                                <Route path='/programa-evaluacion/:unidad?/:programa?/:cohorte?/:anio?/:termino?/:page?/:size?' component={ProgramaEvaluacion} />
                                <Route path='/paralelos-unidad/:unidad?/:anio?/:termino?/:page?/:size?' component={UnidadParalelos} />
                                <Route path='/paralelos-materia/:codigo/:page?/:size?' component={ParalelosMateria} />
                                <Route path='/paralelos-profesor/:identificacion/:page?/:size?' component={ParalelosProfesor} />
                                <Route path='/paralelo/:anio/:termino/:codigo/:paralelo/:identificacion/:modo?' component={Paralelo} />
                                <Route path='/practica/:anio/:codigo/:identificacion/:modo?' component={Practica} />
                                <Route path='/practica-comentarios/:anio/:codigo/:identificacion' component={ComentariosPractica} />
                                <Route path='/reportes-consolidados' component={ReportesConsolidados} />
                                <Route path='/reportes-tecnologias' component={ReportesTecnologias} />
                                <Switch>
                                    <Route path='/paralelo-comentarios/:anio/:termino/:codigo/:paralelo/:identificacion/:idnivelformacion?' component={Comentarios} />
                                    <Route path='/paralelo-comentarios/:sistema/:idcurso/:idpersona' component={Comentarios} />
                                </Switch>
                            </AuthLayoutWrapper>
                        </Switch>
                    </AppContext.Provider>
                </AuthProvider>
            </MsalProviderClient>
        );
    }
}

export default withRouter(App);